(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const shell = main.querySelector('[data-portal-login]');
  const retry = shell?.querySelector('[data-portal-retry]');
  const slowLoad = shell ? window.setTimeout(() => { retry.hidden = false; }, 10000) : null;

  const copy = [
    ['.loop-h2', 'Abonnement-Anmeldelink anfordern', 'Schön, dass du da bist'],
    ['.mt-4 p', 'Geben Sie unten die E-Mail-Adresse an, die Sie für den Kauf des Abonnements verwendet haben. Wir senden Ihnen einen Magic Link an Ihre E-Mail, mit dem Sie sich sofort anmelden können.', 'Trag einfach die E-Mail-Adresse ein, mit der du bestellt hast. Wir schicken dir einen Link, und du bist sofort drin.'],
    ['.loop-btn', 'Abonnement-Anmeldelink senden', 'Login-Link schicken'],
  ];

  const update = () => {
    const login = main.querySelector('#loop-login-body');
    if (!login) return;

    for (const [selector, original, replacement] of copy) {
      const element = login.querySelector(selector);
      if (!element) continue;
      for (const node of element.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === original) {
          node.textContent = replacement;
        }
      }
      if (selector !== '.loop-btn') {
        element.toggleAttribute('data-portal-intro', element.textContent.trim() === replacement);
      }
    }

    const heading = login.querySelector('.loop-h2');
    if (heading) {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', shell ? '2' : '1');
    }
    const email = login.querySelector('input[name="email"]');
    if (email) {
      email.placeholder = 'E-Mail-Adresse';
      email.setAttribute('aria-label', 'E-Mail-Adresse');
      email.setAttribute('autocomplete', 'email');
    }
    if (shell && email && login.querySelector('.loop-btn')) {
      window.clearTimeout(slowLoad);
      retry.hidden = true;
      shell.setAttribute('data-ready', '');
    }
  };

  const observer = new MutationObserver(update);
  observer.observe(main, { childList: true, subtree: true, characterData: true });
  update();
  window.addEventListener('pagehide', () => { observer.disconnect(); window.clearTimeout(slowLoad); });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      observer.observe(main, { childList: true, subtree: true, characterData: true });
      update();
    }
  });
})();
